import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { productCenterContent } from '@/mocks/products';

const products = productCenterContent.items;

export default function ProductCenter() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative overflow-hidden bg-foreground-950">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20dark%20technology%20network%20background%20with%20subtle%20geometric%20connection%20lines%20and%20nodes%2C%20deep%20charcoal%20gray%20tones%20with%20warm%20amber%20and%20muted%20teal%20accent%20highlights%2C%20minimalist%20corporate%20technology%20aesthetic%2C%20no%20glowing%20neon%2C%20no%20blue%20or%20purple%20colors%2C%20professional%20enterprise%20visualization%20with%20depth%2C%20elegant%20and%20restrained%2C%20wide%20format%20banner&width=1600&height=700&seq=pc-hero-v2-01&orientation=landscape"
              alt="产品中心背景"
              title="产品中心背景"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-foreground-950/75" />
          </div>
          <div className="relative w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto pt-36 md:pt-44 pb-16 md:pb-24">
            <nav className="mb-8 flex items-center gap-2 text-sm text-foreground-400">
              <Link to="/" className="hover:text-primary-400 transition-colors">
                首页
              </Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-50 font-medium">产品中心</span>
            </nav>
            <div className="max-w-3xl">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-foreground-50 font-heading leading-tight">
                产品中心
              </h1>
              <p className="mt-6 text-base md:text-lg text-foreground-400 leading-relaxed">
                围绕企业数字化转型与资金安全，构建覆盖AI智能化、业务管理、网银盾智能管理与安全硬件的一体化产品体系。
              </p>
              <div className="mt-10 w-16 h-1 bg-primary-500 rounded-full" />
            </div>
          </div>
        </section>

        {/* Products - alternating layout */}
        <section className="pb-20 md:pb-28">
          <div className="w-full max-w-[1400px] mx-auto">
            {products.map((product, idx) => {
              const isEven = idx % 2 === 0;
              return (
                <div
                  key={product.slug}
                  className={`grid grid-cols-1 lg:grid-cols-2 ${
                    isEven ? '' : 'lg:direction-rtl'
                  }`}
                >
                  {/* Image */}
                  <div className={`relative overflow-hidden ${isEven ? '' : 'lg:order-2'}`}>
                    <Link
                      to={`/product-center/${product.slug}`}
                      className="group block relative h-72 md:h-96 lg:h-[520px]"
                    >
                      <img
                        src={product.image}
                        alt={product.titleCn}
                        title={`${product.titleCn} ${product.titleEn}`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:to-background-50/20" />
                      {/* Number overlay */}
                      <span className="absolute bottom-6 left-6 lg:bottom-10 lg:left-10 text-6xl md:text-8xl font-black text-foreground-50/10 font-heading leading-none select-none">
                        {String(idx + 1).padStart(2, '0')}
                      </span>
                    </Link>
                  </div>

                  {/* Text */}
                  <div
                    className={`flex items-center ${
                      isEven
                        ? 'lg:pl-12 xl:pl-20'
                        : 'lg:pr-12 xl:pr-20 lg:order-1'
                    }`}
                  >
                    <div className="px-4 md:px-8 lg:px-0 py-12 md:py-16 lg:py-20 max-w-xl">
                      <div className="flex items-center gap-3 mb-6">
                        <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500 text-foreground-50">
                          <i className={`${product.icon} text-2xl`} />
                        </div>
                        <span className="text-sm font-medium text-foreground-400 tracking-wide font-label">
                          {product.titleEn}
                        </span>
                      </div>

                      <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-50 font-heading leading-tight">
                        {product.titleCn}
                      </h2>

                      <div className="mt-2 w-12 h-0.5 bg-primary-500 rounded-full" />

                      <p className="mt-6 text-sm md:text-base text-foreground-300 leading-loose">
                        {product.desc}
                      </p>

                      <p className="mt-4 text-sm text-foreground-400 leading-relaxed line-clamp-3">
                        {product.intro}
                      </p>

                      <Link
                        to={`/product-center/${product.slug}`}
                        className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-foreground-50 text-sm font-semibold rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
                      >
                        查看详情
                        <i className="ri-arrow-right-line" />
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* Bottom CTA */}
        <section className="bg-background-100 py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto text-center">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
              了解更多产品与解决方案
            </h2>
            <p className="mt-4 text-sm text-foreground-300 max-w-lg mx-auto">
              析莜科技为央国企与大型企业提供安全、高效、可视、可控的完整数字化解决方案，欢迎咨询了解。
            </p>
            <div className="mt-8 flex items-center justify-center gap-4 flex-wrap">
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-foreground-50 text-sm font-semibold rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                返回首页
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}